import CenteredContainer from '../../components/centeredContainer';

import './style.scss';
import ForgotPasswordForm from "./forgotPasswordForm";
import {useSelector} from "react-redux";
import {Navigate} from "react-router-dom";
import {route as LOGIN_ROUTE} from "../login/"

export const route = '/forgot-password';

const ForgotPassword = (props) => {
  const forgotPasswordSuccess = useSelector((state) => state.session.forgotPasswordSuccess);

  return (forgotPasswordSuccess) ? <Navigate to={LOGIN_ROUTE}/> : (
    <CenteredContainer>
      <div className='forgot-password-container'>
        <ForgotPasswordForm />
      </div>
    </CenteredContainer>
  )
};

export default ForgotPassword;